// Uncomment this line on creating a translation file
import { surveyLocalization } from "../surveyStrings";

export var japaneseSurveyStrings = {
  pagePrevText: "前の",
  pageNextText: "次へ",
  completeText: "完了",
  startSurveyText: "スタート",
  otherItemText: "その他（説明）",
  noneItemText: "なし",
  selectAllItemText: "すべて選択",
  progressText: "{0}/{1}頁",
  emptySurvey: "この調査に表示できるページや質問はありません",
  completingSurvey: "調査を完了してくれてありがとうございました",
  loadingSurvey: "調査をダウンロード中",
  optionsCaption: "選択",
  requiredError: "質問にお答え下さい",
  numericError: "数字でご記入下さい",
  textMinLength: "{0} 文字以上で入力して下さい",
  minRowCountError: "{0}行以上で入力して下さい",
  minSelectError: "{0}種類以上を選択して下さい",
  numericMin: "'{0}' は同等か{1}より大きくなければなりません",
  numericMax: "'{0}' は同等か{1}より小さくなければなりません",
  invalidEmail: "有効なメールアドレスをご記入下さい",
  exceedMaxSize: "ファイルのサイズは{0}を超えてはいけません",
  uploadingFile:
    "ファイルをアップロード中です。しばらくしてから再度お試し下さい",
  loadingFile: "読み込み中",
  chooseFile: "ファイルを選択",
  cleanCaption: "削除",
  clearCaption: "空白",
  removeFileCaption: "このファイルを削除"
};

//Uncomment these two lines on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
surveyLocalization.locales["ja"] = japaneseSurveyStrings;
surveyLocalization.localeNames["ja"] = "日本語";



// WEBPACK FOOTER //
// ./src/localization/japanese.ts


// WEBPACK FOOTER //
// webpack:///src/localization/japanese.ts